import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NgcCookieConsentModule } from 'ngx-cookieconsent';

import { ICredentials, TwcI18nModule, TwcTopconOneCredentials } from '@topcon/twc-angular';

import { MagnetService } from '@mirage-projects/cw-commons';

import { environment } from '@collageweb/environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrandBarModule } from './components/brand-bar/brand-bar.module';
import { FooterModule } from './components/footer/footer.module';
import { SidebarModule } from './components/sidebar/sidebar.module';
import { cookieConsentConfig } from './services/cookie-consent/cookie-consent-configuration';
import { CustomLoader } from './services/translate/custom-loader';
import { SharedModule } from './shared.module';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        SharedModule,
        NgcCookieConsentModule.forRoot(cookieConsentConfig),
        BrandBarModule,
        SidebarModule,
        FooterModule,
        TwcI18nModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: CustomLoader,
                deps: [HttpClient, MagnetService],
            },
        }),
    ],
    providers: [
        {
            provide: TwcTopconOneCredentials,
            useFactory: (): ICredentials => environment.configuration?.topconOne,
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
